/**
 * @file reportMouseSdkError.ts
 * @description 鼠标页面 SDK 错误统一记录。
 */

import { defaultReportError } from '@/composables/useErrorLogger'

type DeviceLikeError = {
  message?: unknown
}

export function reportMouseSdkError(action: string, error: unknown): void {
  const message = getErrorMessage(error)
  defaultReportError(`${action}: ${message}`)
}

function getErrorMessage(error: unknown): string {
  if (error instanceof Error && error.message) return error.message
  if (isObject(error) && typeof (error as DeviceLikeError).message === 'string') {
    return (error as DeviceLikeError).message as string
  }
  try {
    return JSON.stringify(error) ?? String(error)
  } catch {
    return String(error)
  }
}

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}
